import Alpine from 'alpinejs';
import { initPageQaMedia } from './page-qa-media';

window.Alpine = Alpine;
Alpine.start();

initPageQaMedia();

// Initialize desktop menu toggle when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    const desktopMenuButton = document.getElementById('desktop-menu-button');
    const desktopMenu = document.getElementById('desktop-menu');

    if (desktopMenuButton && desktopMenu) {
        desktopMenuButton.addEventListener('click', function (e) {
            e.stopPropagation();
            desktopMenu.classList.toggle('hidden');
        });
    }
});

window.mobileSubMenu = (event) => {
    const isBack = event.getAttribute('data-back');
    if (isBack) {
        event.parentNode.closest('div').classList.toggle('hidden');
    } else {
        event.nextElementSibling.classList.toggle('hidden');
    }
}

// Attach autocomplete to #location input field for "Too Busy to Search" form
document.addEventListener('DOMContentLoaded', function() {
    const location = document.getElementById('location');
    if (location) {
        // Create a callback to update hidden form fields when a place is selected
        const updatePlaceInfoForForm = (placeInfo) => {
            const form = location.closest('form');
            if (form) {
                const latInput = form.querySelector('.search-lat');
                const lngInput = form.querySelector('.search-lng');
                const typeInput = form.querySelector('.search-type');
                const formattedAddressInput = form.querySelector('.search-formatted-address');
                
                if (latInput) latInput.value = placeInfo.lat || '';
                if (lngInput) lngInput.value = placeInfo.lng || '';
                if (typeInput) typeInput.value = placeInfo.type || '';
                if (formattedAddressInput) formattedAddressInput.value = placeInfo.customFormattedAddress || placeInfo.search || '';
            }
        };
        
        location.addEventListener('input', (e) => {
            handleAutocomplete(e, updatePlaceInfoForForm);
        });
    }
});

window.closeModal = document.getElementById("close-modal");
window.closeStudioModal = document.getElementById("close-studio-modal");
window.overlay = document.querySelector(".overlay");
window.overlayBody = document.querySelector(".overlay-body");
window.overlayBodyMaps = document.querySelector(".overlay-body-maps");
window.modalStudio = document.querySelector(".modal-studio");
window.overlayModalStudio = document.querySelector(".overlay-image-modal");
window.modal = document.getElementById("modal");
window.oBodyModal = modalStudio? modalStudio.querySelector('.body-modal'):null;
window.bodyModal = document.getElementById("body-modal");
window.mapsModal = document.getElementById("maps-modal");
window.mapsBodyModal = document.getElementById("maps-body-modal");
window.popCarousel = document.getElementById("default-carousel");
window.iframeTour = document.getElementById("iframe-tour");

// mobile menu
const mobileMenuToggle = document.querySelector(".mobile-menu-toggle");
const mobileNav = document.querySelector(".mobile-nav");
const $prevButton = document.getElementById('data-carousel-prev');
const $nextButton = document.getElementById('data-carousel-next');
const btnNxt = document.getElementById('btn-next');
const btnPrev = document.getElementById('btn-prev');

if (mobileMenuToggle && mobileNav) {
    mobileMenuToggle.addEventListener('click', () => {
        mobileMenuToggle.classList.toggle('mobile-menu-toggle--active');
        mobileNav.classList.toggle('hidden');
        mobileNav.classList.toggle('hide');
        mobileNav.classList.toggle('fixed');
        mobileNav.classList.toggle('show');
        const isExpanded = mobileMenuToggle.classList.contains('mobile-menu-toggle--active');
        mobileMenuToggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    });
}
/*
search bar mobile
 */
document.addEventListener('click', (e) => {
    if (overlayBodyMaps === e.target) {
        overlayBodyMaps.classList.add("hidden");
    }
    if (overlayModalStudio === e.target || modalStudio === e.target || closeStudioModal === e.target) {
        modalStudio.classList.add("hidden");
        overlayModalStudio.classList.add("hidden");
        btnPrev.classList.add('hidden');
        btnNxt.classList.add('hidden');
        document.body.classList.remove('modal-open');
        oBodyModal.innerHTML='';
    }

    if (overlayBody === e.target) {
        overlayBody.classList.add("hidden");
        const iframePopup = document.getElementById('iframe-popup');
        if (iframePopup) {
            iframePopup.remove();
        }
        const videoCLose = document.querySelector('video');
        if (videoCLose) {
            videoCLose.pause();
        }
        document.body.classList.remove('modal-open');
        if (bodyModal) bodyModal.innerHTML='';
        popCarousel.classList.add('hidden');
        $nextButton.classList.add('hidden');
        $prevButton.classList.add('hidden');
        modal.classList.add("transition", "ease-in-out", "delay-150");
    }
})
window.setCookie = (name, value, days = 1000) => {
    let expires = "";
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
window.getCookie = (name) => {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}
const empty = async () => {
}
window.empty = empty;

window.isResponsiveOn =()=> {
    return !window.matchMedia('(min-width: 768px)').matches;
}

/**
 * True when the serviced-offices search page is in desktop split map layout (map FAB hidden).
 * Matches `@screen md-992` for `.map-mode-toggle { display: none }` in app.css.
 * Use for eager Google Maps load — avoids the API request while only the map/list FAB shows (768–991px).
 */
window.isSearchResultsMapInDesktopSplitView = () => {
    return window.matchMedia('(min-width: 992px)').matches;
};

window.handleAutocomplete = (event, updatePlaceInfo) => {
    if (event.target.value.length < 4) return false;

    const container = document.createElement('div');

    let autocompleteContainer = event.target.parentNode.querySelector('.autocomplete-container');
    if (autocompleteContainer) {
        autocompleteContainer.remove();
    }
    container.classList.add('autocomplete-container', 'invisible');
    event.target.parentNode.insertBefore(container, event.target.nextSibling);
    const dropdown = document.createElement('div');
    dropdown.setAttribute('class', 'autocomplete-dropdown');
    dropdown.setAttribute('id', 'autocomplete-dropdown');
    if (event.target.id === 'location') dropdown.classList.add('h-[220px]');
    container.appendChild(dropdown);

    const service = new google.maps.places.AutocompleteService();
    const request = {
        input: event.target.value,
        types: ['geocode', 'establishment']
    };
    service.getPlacePredictions(request, function (predictions, status) {
        if (status === google.maps.places.PlacesServiceStatus.OK && predictions && predictions.length > 0) {
            dropdown.innerHTML = '';
            container.classList.remove('invisible');
            for (let i = 0; i < predictions.length; i++) {
                const itemParent = document.createElement('div');
                const item = document.createElement('p');
                item.classList.add("auto_complete_item_text");
                const flag = document.createElement('p');
                flag.classList.add("auto_complete_item_pin_marker");
                flag.innerHTML = '<span class="pin_map p-2"> </span>';
                itemParent.appendChild(item)
                itemParent.appendChild(flag)
                itemParent.classList.add('autocomplete-item', 'flex', 'flex-row-reverse', 'w-full');
                itemParent.setAttribute('data-place-id', predictions[i].place_id);
                itemParent.setAttribute('data-search-type', predictions[i].types.join('|'));
                item.innerHTML = predictions[i].description;
                dropdown.appendChild(itemParent);
                itemParent.addEventListener('click', function (e) {
                    /* Stop bubble so header @click.outside on the wrapper does not treat this as an
                     * outside click and collapse the panel while selecting a suggestion. */
                    e.stopPropagation();
                    let placeId = this.getAttribute('data-place-id');
                    let searchTypes = this.getAttribute('data-search-type').split('|');
                    let service = new google.maps.places.PlacesService(container);
                    service.getDetails({placeId: placeId}, function (place, status) {
                        if (status === google.maps.places.PlacesServiceStatus.OK) {
                            let customFormattedAddress = [];
                            if (event.target.id === 'location') {
                                event.target.value = place.formatted_address;
                                // Update hidden form fields for location input
                                if (updatePlaceInfo) {
                                    let placeInfo = {
                                        isNewDesign: true,
                                        search: place.formatted_address,
                                        lat: place.geometry.location.lat(),
                                        lng: place.geometry.location.lng(),
                                        customFormattedAddress: place.formatted_address,
                                        type: place.types && place.types.length > 0 ? place.types[0] : ''
                                    };
                                    updatePlaceInfo(placeInfo);
                                }

                                return false;
                            }
                            let countryArray = place.address_components.filter(function (a) {
                                return a.types.includes("country") ? a : null;
                            });
                            let countryName = "";
                            var intersection = place.address_components[i].types.map(function (a) {
                                return searchTypes.indexOf(a) < 0 ? null : a;
                            });
                            if (countryArray.length > 0) {
                                countryName = countryArray[0].short_name;
                            }
                            for (let i = 0; i < place.address_components.length; i++) {
                                if (intersection.length > 0) {
                                    if (["administrative_area_level_1", "administrative_area_level_2"].some(type => place.address_components[i].types.includes(type))) {
                                        if (countryName === "US") {
                                            let placeComponent = place.address_components[i].long_name.toLowerCase();
                                            if (customFormattedAddress.indexOf(placeComponent) < 0) {
                                                customFormattedAddress.push(placeComponent);
                                            }
                                        }
                                    } else {
                                        let placeComponent = place.address_components[i].short_name.toLowerCase();
                                        if (customFormattedAddress.indexOf(placeComponent) < 0) {
                                            customFormattedAddress.push(placeComponent);
                                        }
                                    }
                                }
                            }
                            let placeInfo = {
                                isNewDesign: true,
                                search: place.formatted_address,
                                lat: place.geometry.location.lat(),
                                lng: place.geometry.location.lng(),
                                customFormattedAddress: customFormattedAddress.join(', '),
                                type: place.types.shift()
                            };

                            if (updatePlaceInfo) {
                                updatePlaceInfo(placeInfo);
                            }
                        }
                    });
                    dropdown.innerHTML = '';
                });
            }
        } else {
            dropdown.innerHTML = 'No found ';
        }
    });
    document.addEventListener('click', function (event) {
        if (!container.contains(event.target)) {
            dropdown.innerHTML = '';
            container.classList.add('invisible');
        }
    });
};


document.addEventListener('click', e => {
    const desktopMenu = document.getElementById('desktop-menu');
    const desktopMenuButton = document.getElementById('desktop-menu-button');

    if (desktopMenu && desktopMenuButton) {
        // Check if click is outside the menu and button
        if (!desktopMenu.contains(e.target) && !desktopMenuButton.contains(e.target)) {
            desktopMenu.classList.add('hidden');
        }
    }
});
window.buildSlider = (items, autoPlay,id=0,type='main') => {
    let optional = {defaultPosition: 0, interval: 4000}
    if (items.length > 1) {
        const carousel = new Carousel(items, optional);
        const $_prevButton = document.getElementById('btn-prev');
        const $_nextButton = document.getElementById('btn-next');
        let currentSlide =  1;
        let imageNumber = null;
        let totalSlides = carousel._items.length;
        if (type ==='main'){
            if (popCarousel.querySelector('.image-slider-number')){
                popCarousel.querySelector('.image-slider-number').remove();
            }
            imageNumber = document.createElement('p');
            imageNumber.setAttribute('class','image-slider-number');
            imageNumber.innerText=`${currentSlide} of ${totalSlides}`;
            popCarousel.appendChild(imageNumber);
        }
        $prevButton.addEventListener('click', () => {
            if (currentSlide>1){
                carousel.prev();
                if (imageNumber) imageNumber.innerText=`${--currentSlide} of ${totalSlides}`;
            }else {
                currentSlide =totalSlides;
                carousel.slideTo(--currentSlide);
                if (imageNumber) imageNumber.innerText=`${totalSlides} of ${totalSlides}`;

            }
        });
        $nextButton.addEventListener('click', () => {
            if (currentSlide<totalSlides){
                carousel.next();
                if (imageNumber) imageNumber.innerText=`${++currentSlide} of ${totalSlides}`;
            }else {
                carousel.slideTo(0);
                currentSlide=1;
                if (imageNumber) imageNumber.innerText=`1 of ${totalSlides}`;
            }

        });
        $_prevButton.addEventListener('click', () => {
            if (currentSlide>1){
                carousel.prev();
                if (imageNumber) imageNumber.innerText=`${--currentSlide} of ${totalSlides}`;
            }else {
                currentSlide = totalSlides;
                carousel.slideTo(--currentSlide);
                if (imageNumber) imageNumber.innerText=`${totalSlides} of ${totalSlides}`;
            }
        });
        $_nextButton.addEventListener('click', () => {
            if (currentSlide<totalSlides){
                carousel.next();
                if (imageNumber) imageNumber.innerText=`${++currentSlide} of ${totalSlides}`;
            }else {
                carousel.slideTo(0);
                currentSlide=1;
                if (imageNumber) imageNumber.innerText=`1 of ${totalSlides}`;
            }
        });
        if (id){
            carousel.slideTo(id);
        }
        carousel.pause()
    }
}
window.isVideoLink = function isVideoLink(link) {
    if (!link) return false;
    link = link.split('#')[0].split('?')[0];
    const extension = link.split('.').pop().toLowerCase();
    const videoExtensions = ['mp4', 'avi', 'mov', 'wmv', 'mkv', 'flv', 'webm'];
    return videoExtensions.includes(extension);
}

window.withYoutubeAutoplay = function withYoutubeAutoplay(url) {
    if (!url || url.indexOf('youtube.com/embed') === -1) {
        return url;
    }
    try {
        const parsed = new URL(url);
        parsed.searchParams.set('autoplay', '1');
        return parsed.toString();
    } catch (e) {
        return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'autoplay=1';
    }
}

window.openWorkspaceYoutube = function openWorkspaceYoutube(el, event) {
    if (event) {
        event.stopPropagation();
    }
    if (typeof isResponsiveOn === 'function' && isResponsiveOn()) {
        const watchUrl = el.getAttribute('data-youtube-watch');
        if (watchUrl) {
            window.open(watchUrl, '_blank', 'noopener');
        }
        return false;
    }
    openStudioBrowser(el);
    return false;
}

window.openStudioBrowser = function (e,type='default') {
    if (type === 'default' && isResponsiveOn()){
        return false;
    }
    const srcImage = Array.from(e.parentElement.querySelectorAll("[data-src]")).filter((ele) => {
        const dataSrc = ele.getAttribute('data-src');
        return dataSrc && dataSrc !== 'null';
    });
    const {id} = e.dataset;
    let tourLInk = e.getAttribute('data-link');
    const carouselBodyPopup = popCarousel.querySelector('div:first-child');
    carouselBodyPopup.innerHTML = "";
    const items = [];
    let hasVideo = false;
    if (tourLInk && !isVideoLink(tourLInk)){
        tourLInk = withYoutubeAutoplay(tourLInk);
        const allowAttrs = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        const posterUrl = e.getAttribute('data-youtube-poster')
            || (e.querySelector('img') && e.querySelector('img').getAttribute('src'))
            || '';
        carouselBodyPopup.innerHTML = '';
        const node = document.createElement('div');
        node.setAttribute('id', 'iframe-popup');

        if (posterUrl) {
            const poster = document.createElement('img');
            poster.className = 'youtube-iframe-poster';
            poster.src = posterUrl;
            poster.alt = '';
            poster.setAttribute('aria-hidden', 'true');
            node.appendChild(poster);
        }

        const iframe = document.createElement('iframe');
        iframe.className = 'w-full h-full';
        iframe.id = 'iframe-tour';
        iframe.src = tourLInk;
        iframe.setAttribute('allow', allowAttrs);
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allowfullscreen', '');
        if (posterUrl) {
            iframe.addEventListener('load', function onYoutubeIframeLoad() {
                const posterEl = node.querySelector('.youtube-iframe-poster');
                if (posterEl) {
                    posterEl.classList.add('is-hidden');
                }
                iframe.removeEventListener('load', onYoutubeIframeLoad);
            });
        }
        node.appendChild(iframe);
        carouselBodyPopup.appendChild(node);

    }else if (isVideoLink(tourLInk)){
        carouselBodyPopup.innerHTML = '';
        let newItemVideo = document.createElement('video');
        newItemVideo.setAttribute('class', 'absolute block -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 b-lazy');
        newItemVideo.setAttribute('src', tourLInk);
        newItemVideo.setAttribute('controls', 'controls');
        newItemVideo.setAttribute('autoplay', 'autoplay');
        newItemVideo.muted = true;
        newItemVideo.autoplay = true;
        carouselBodyPopup.appendChild(newItemVideo);
        hasVideo = true;
    }
    else if (srcImage.length === 1) {
        const ele = srcImage[0];
        let eleSrc = ele.getAttribute('src') || ele.getAttribute('data-src');
        let eleAlt = ele.getAttribute('alt');
        if (isVideoLink(eleSrc)) {
            let newItemVideo = document.createElement('video');
            newItemVideo.setAttribute('class', 'absolute block -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 b-lazy');
            newItemVideo.setAttribute('src', eleSrc);
            newItemVideo.setAttribute('controls', 'controls');
            newItemVideo.setAttribute('autoplay', 'autoplay');
            newItemVideo.muted = true;
            newItemVideo.autoplay = true;
            carouselBodyPopup.appendChild(newItemVideo);
            hasVideo = true;
        } else if (eleSrc) {
            let newItemImg = document.createElement('img');
            newItemImg.setAttribute('class', 'block mx-auto max-h-screen');
            newItemImg.setAttribute('src', eleSrc);
            newItemImg.setAttribute('alt', eleAlt);
            carouselBodyPopup.appendChild(newItemImg);
        }
    } else {
        srcImage.forEach((ele, inx) => {
            let eleSrc = ele.getAttribute('data-src');
            let eleAlt = ele.getAttribute('alt');
            if (!eleSrc || eleSrc === 'null') {
                return;
            }
            let newItemDiv = document.createElement('div');
            newItemDiv.setAttribute('id', `carousel-item-${inx}`);
            newItemDiv.setAttribute('class', 'hidden duration-700 ease-in-out');
            newItemDiv.setAttribute('data-carousel-item', '');
            if (isVideoLink(eleSrc)){
                let newItemVideo = document.createElement('video');
                newItemVideo.setAttribute('class', 'absolute block -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 b-lazy');
                newItemVideo.setAttribute('src', eleSrc);
                newItemVideo.setAttribute('controls', 'controls');
                newItemVideo.setAttribute('autoplay', 'autoplay');
                newItemVideo.muted = true;
                newItemVideo.autoplay = true;
                newItemDiv.appendChild(newItemVideo);
                hasVideo = true;

            }else{
                let newItemImg = document.createElement('img');
                newItemImg.setAttribute('class', 'absolute block -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2');
                newItemImg.setAttribute('src', eleSrc);
                newItemImg.setAttribute('alt', eleAlt);
                newItemDiv.appendChild(newItemImg);
            }
            carouselBodyPopup.appendChild(newItemDiv);
            items.push({
                position: inx,
                el: newItemDiv
            });
        });
    }
    buildSlider(items, !hasVideo,id,type);
    if(type ==='main'){
        bodyModal.innerHTML='';
        bodyModal.appendChild(popCarousel);
        popCarousel.classList.remove('hidden');
        overlayBody.classList.remove("hidden");
        $prevButton.classList.remove('hidden');
        $nextButton.classList.remove('hidden');
        document.body.classList.add('modal-open');
    }else {
        if (oBodyModal){
            oBodyModal.innerHTML='';
            oBodyModal.appendChild(popCarousel);
        }
        let sliderNumber = popCarousel.querySelector('.image-slider-number');
        if (sliderNumber){
            sliderNumber.remove();
        }
        popCarousel.classList.remove('hidden');
        if(items.length >0){
            btnPrev.classList.remove('hidden');
            btnNxt.classList.remove('hidden');
        }
        overlayModalStudio.classList.remove('hidden');
        document.body.classList.add('modal-open');
        modalStudio.classList.remove('hidden');
    }
}

window.openTour = function (e) {
    let tourLInk = e.getAttribute('data-link');
    const innerIframe = `<iframe class="w-full h-full" id="iframe-tour" src="${tourLInk}" allow="autoplay;" frameborder="0" allowfullscreen allow="vr"></iframe>`;
    bodyModal.innerHTML = '';
    const node = document.createElement('div');
    node.setAttribute('id', 'iframe-popup')
    node.innerHTML = innerIframe;
    bodyModal.appendChild(node);
    overlayBody.classList.add("flex");
    overlayBody.classList.remove("hidden");
}

window.addToShortList = (e, isIcon = false) => {
    const officeId = e.getAttribute('data-id');
    let poptext = null;
    if (officeId == null)
        return;
    const iconEl = e.tagName === 'svg' ? e : e.querySelector('svg');
    if (isIcon) {
        poptext = e.nextElementSibling.querySelector('p');
    }
    let shortlist = getCookie('shortlist');
    const popoverDescription = document.getElementById('popover-description');
    const number = document.querySelector('span.number');
    let shortListCount = number.innerText ? parseInt(number.innerText) : 0;
    let shortListArray = shortlist ? decodeURIComponent(shortlist).split(',') : [];
    if (shortListArray && shortListArray.includes(officeId)) {
        if (iconEl) {
            iconEl.classList.remove('heart', 'shortlist-active');
        }
        shortListArray = shortListArray.filter(item => item !== officeId);
        if (!isIcon) e.innerText = "Add To Enquiry";
        if (isIcon) {
            poptext.innerText = 'Add To Enquiry';
        }
        number.innerText = shortListCount - 1;
    } else {
        shortListArray.push(officeId);
        if (!isIcon) e.innerText = "Remove From Enquiry";
        if (isIcon) {
            poptext.innerText = 'Remove From Enquiry';
        }
        if (iconEl) iconEl.classList.add('heart', 'shortlist-active');
        number.innerText = shortListCount + 1;
        popoverDescription.classList.remove('invisible');
        popoverDescription.classList.add('visible', 'opacity-100');
        const p = popoverDescription.querySelector('p');
        p.innerHTML = "Successfully added to your enquiry!";
        setTimeout(() => {
            popoverDescription.classList.remove('visible', 'opacity-100');
            popoverDescription.classList.add('invisible');
            p.innerHTML = "";
        }, 3000);
    }

    setCookie('shortlist', encodeURIComponent(shortListArray.join(',')));
}

window.slideImage = (className='.co-carousel')=>{
    const carousels = document.querySelectorAll(className);
    carousels.forEach((carousel) => {
        const container = carousel.querySelector('.carousel-container');
        const items = carousel.querySelectorAll('.carousel-item');
        const itemCount = items.length;
        if(itemCount < 1) return false;
        const itemWidth = items[0].offsetWidth;
        let currentIndex = 0;
        function moveCarousel() {
            container.style.transform = `translateX(-${currentIndex * itemWidth}px)`;
        }
        function handlePrev() {
            if (currentIndex > 0) {
                currentIndex--;
                moveCarousel();
            }else {
                currentIndex = itemCount;
                --currentIndex;
                moveCarousel();
            }
        }

        function handleNext() {
            if (currentIndex < itemCount - 1) {
                currentIndex++;
                moveCarousel();
            }else {
                currentIndex=0;
                moveCarousel();
            }
        }

        carousel.querySelector('.prev-button').addEventListener('click', handlePrev);
        carousel.querySelector('.next-button').addEventListener('click', handleNext);
    });
}

window.loadScript =function (src, callback) {
    let script = document.createElement('script');
    script.src = src;
    script.onload = callback;
    document.body.append(script);
}

document.addEventListener('DOMContentLoaded', function () {
    if (isResponsiveOn()){
        const mobileChatButton = document.querySelector('.mobile-chat-button');
        mobileChatButton.addEventListener('click',()=>{
            loadScript('/website/js/intercom.js', function() {
                Intercom('show');
                console.log('Script intercom loaded!');
            });
        });
    }
});

const loadLazyImage = function(image) {
    const src = image.getAttribute('data-src');
    if (!src) return;
    image.src = src;
}
let options = {
    rootMargin: '0px',
    threshold: 0.9
};

const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            loadLazyImage(entry.target);
            observer.unobserve(entry.target);
        }
    });
},options);
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('img.lazyload').forEach(img => {
        observer.observe(img);
    });
});
